/**
 * Accueil : catégories en panneaux (sections/accueil-categories.liquid). Un panneau toujours ouvert :
 * clic ou appui sur un autre l'ouvre et referme le précédent. Sur ordinateur, avec la souris, le
 * survol ouvre aussi après 140 ms (on peut traverser les panneaux sans tout ouvrir). Au clavier, le
 * focus passe dans le panneau ouvert. Dans l'éditeur de thème, la catégorie choisie s'ouvre.
 */
const ordinateur = window.matchMedia('(min-width: 990px)');

class PsCategories extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.panels = [...this.querySelectorAll('.ps-cat__panel')];
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.panels.forEach((panel, k) => {
      const button = panel.querySelector('.ps-cat__btn');
      button.addEventListener('click', (e) => this.open(k, { focus: e.detail === 0 || e.pointerType === '' }), { signal });
      panel.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse' || this.dataset.hover === 'false' || !ordinateur.matches) return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.open(k), 140);
      }, { signal });
      panel.addEventListener('pointerleave', () => clearTimeout(this.timer), { signal });
    });
    document.addEventListener('shopify:block:select', (e) => {
      const k = this.panels.indexOf(e.target);
      if (k >= 0) this.open(k);
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
    clearTimeout(this.timer);
    this.ready = false;
  }

  open(k, { focus = false } = {}) {
    clearTimeout(this.timer);
    const current = this.panels.findIndex((p) => p.classList.contains('is-open'));
    if (current === k) return;
    this.panels.forEach((panel, j) => {
      const on = j === k;
      const button = panel.querySelector('.ps-cat__btn');
      const body = panel.querySelector('.ps-cat__body');
      panel.classList.toggle('is-open', on);
      button.hidden = on;
      button.setAttribute('aria-expanded', on ? 'true' : 'false');
      body.hidden = !on;
    });
    const panel = this.panels[k];
    // Le bouton cliqué disparaît : au clavier, le focus passe dans le panneau ouvert.
    if (focus) panel.querySelector('.ps-cat__body').focus({ preventScroll: true });
    // Accordéon : le panneau ouvert reste à l'écran, sous l'en-tête collant, quand celui du dessus se referme.
    if (!ordinateur.matches) {
      const entete = Math.max(0, ...[...document.querySelectorAll('.shopify-section-group-header-group')]
        .filter((s) => /sticky|fixed/.test(getComputedStyle(s).position))
        .map((s) => s.getBoundingClientRect().bottom));
      const top = panel.getBoundingClientRect().top;
      if (top < entete) window.scrollBy({ top: top - entete - 8, behavior: 'auto' });
    }
  }
}

if (!customElements.get('ps-categories')) customElements.define('ps-categories', PsCategories);
